import React from 'react';
import { Link } from 'react-router-dom';
import { DoubleArrow } from '@material-ui/icons';
import '../../css/player.css';

import Loader from 'react-simple-loading';

// utils
import { observer } from 'mobx-react';

import callApi from '../../utils/callApi';
import ArchiveDateStore from '../../store/ArchiveDateStore';
import SimpleVideoPlayer from '../blogComponents/SimpleVideoPlayer';

// constants
import {
  FETCH_VIDEO_SEGMENT_BY_ID,
  FETCH_VIDEO_VINTAGE_BY_ID,
  FETCH_VIDEO_AUDITION_PREVIEW_BY_ID,
  FEAUTRED_BY_ID,
} from '../../constants/apiUrls/apiUrls';

import '../../css/player.css';
import VideoPlayerStore from '../../store/VideoPlayerStore';

import PlayerInfo from './PlayerInfo';


const text = {
  unlock: 'Unlock this segment',
  onlyMembers: 'Only Naked News members can watch this',
  clickHere: 'Click here to get access',
};

class LockedVideo extends React.Component {

  state = { program: null, featuredVideo: null, loading: false };

  decideUrl = () => {
    const { videoElement, typeOfListing } = this.props;
    if (typeof videoElement !== 'undefined') {
      switch (typeOfListing) {
        case 'all':
          return FETCH_VIDEO_SEGMENT_BY_ID.replace(
            '{id}',
            videoElement.programSegmentId
          );
        case 'audition':
          return FETCH_VIDEO_AUDITION_PREVIEW_BY_ID.replace(
            '{id}',
            videoElement.auditionId
          );
        case 'vintage':
          return FETCH_VIDEO_VINTAGE_BY_ID.replace(
            '{id}',
            videoElement.id
          );
        case 'date':
          return FETCH_VIDEO_SEGMENT_BY_ID.replace(
            '{id}',
            videoElement.programSegmentId
          );
        default:
          return FETCH_VIDEO_SEGMENT_BY_ID.replace(
            '{id}',
            videoElement.programSegmentId
          );
      }
    }
  };

  fetchFeaturedClip = () => {
    this.setState({ loading: true });
    const searchParams = new URLSearchParams(window.location.search);

    const featuredId = searchParams.get('featuredId');

    if (featuredId) {
      callApi(FEAUTRED_BY_ID.replace('{id}', featuredId), 'get').then((res) => {
        this.setState({ featuredVideo: res.data});
        this.setState({ loading: false });
      })
    } else {
      this.setState({ loading: false });
    }
  }

  fetchMainProgram = (url) => {
    callApi(url, 'get', { showDescription: true }).then((res) => {
      const program = res.data;
      this.setState({ program });
      VideoPlayerStore.setProgramData({ program: res.data, programSegments: [res.data], currentPosition: 0 });
    });
  };

  componentDidMount() {
    this.fetchMainProgram(this.decideUrl());
    this.fetchFeaturedClip();
  }

  componentDidUpdate(prevProps) {
    if (prevProps?.videoElement?.programSegmentId !== this.props?.videoElement?.programSegmentId) {
      this.fetchMainProgram(this.decideUrl());
      this.fetchFeaturedClip();
    }
  }

  componentWillUnmount() {
    VideoPlayerStore.setProgramData({ program: undefined, programSegments: undefined, currentPosition: undefined });
  }

  getMonthName = (num) => {
    let mNum = ++num;
    mNum < 10 ? (mNum = `0${mNum}`) : (mNum = `${mNum}`);
    const month = ArchiveDateStore.months.find((m) => m.number === mNum);

    return month && month.name;
  };

  render() {
    const {
      videoElement,
      typeOfListing,
      customBackgroundColor,
      user,
    } = this.props;
    const { program, featuredVideo, loading } = this.state;
    const imgUrl = program && program.clip && program.clip.imageUrl;
    const { imageUrl } = videoElement;

    return (
      <div
        className="masthead mh-1"
        style={{ backgroundColor: customBackgroundColor ? customBackgroundColor : '#252525' }}
      >
        <div className="container">
          <div
            className="clearfix video-player-container locked"
            id="video-player-container"
          >
            {!featuredVideo && !loading && <div className="locked-player">
              <div className="clearfix">
                <div className="player-zone">
                  <Link
                    className="video video-player"
                    style={{ display: 'block' }}
                    to="/account/purchase"
                  >
                    <img
                      alt="program-banner"
                      className="img-responsive"
                      src={
                        videoElement.bannerImage ||
                        imgUrl ||
                        imageUrl ||
                        (program && program.bannerImage)
                      }
                    />
                    <div className="blackout-container">
                      <div className="blackout">
                        <div className="blackout-title">
                          {text.unlock}
                        </div>
                        <div className="blackout-text">
                          {text.onlyMembers}
                        </div>
                        <div className="blackout-button btn btn-lg btn-primary">
                          {text.clickHere}
                          <div className="icons-group">
                            <DoubleArrow fontSize="inherit" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>}
            {loading && <Loader color="white" />}
            {featuredVideo && <SimpleVideoPlayer clip={featuredVideo} isNNLSection={true} />}
            <PlayerInfo isSubscribed={false} typeOfListing={typeOfListing} user={user} />
          </div>
        </div>
      </div>
    );
  }
}

export default observer(LockedVideo);
